var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCancelEditing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9581",
  d: "M8 8.933 4.733 12.2a.63.63 0 0 1-.467.183.63.63 0 0 1-.466-.183.63.63 0 0 1-.184-.467q0-.283.184-.466L7.066 8 3.8 4.733a.63.63 0 0 1-.184-.466q0-.284.184-.467a.63.63 0 0 1 .466-.183q.285 0 .467.183L8 7.067 11.266 3.8a.63.63 0 0 1 .467-.183q.283 0 .466.183a.63.63 0 0 1 .184.467.63.63 0 0 1-.183.466L8.933 8l3.267 3.267a.63.63 0 0 1 .183.466.63.63 0 0 1-.183.467.63.63 0 0 1-.467.183.63.63 0 0 1-.467-.183z"
})));
export default SvgCancelEditing;